import { Button } from '@common-components';
import { PlacementType, RemarketEligibilityStatus } from 'enums';
import { messages } from 'i18n';
import { BROKER_NESTED_ROUTES } from 'broker/broker-routes';
import { getRemarketingEligibilityConfig } from 'broker/configuration-mappers/submission-remarketing-eligibility-config';
import { RouteKey } from 'broker/enums';
import { useNavigate } from 'broker/hooks';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export default function StartMarketingButton() {
  const navigate = useNavigate();
  const { partialSubmission } = useSubmissionsWorkspace();
  const { remarketEligibility } = partialSubmission || {};
  const isDirectPlacementSubmission = partialSubmission?.placementType === PlacementType.Direct;

  const variant =
    !isDirectPlacementSubmission || remarketEligibility?.status === RemarketEligibilityStatus.Eligible
      ? 'contained'
      : 'outlined';

  const onStartMarketingClick = () => {
    navigate(BROKER_NESTED_ROUTES.WORKSPACE.ADD_PRODUCTS, {
      routeKey: RouteKey.AddProducts,
      state: undefined,
    });
  };

  return (
    <Button
      variant={variant}
      onClick={onStartMarketingClick}
      tooltipContent={
        isDirectPlacementSubmission ? getRemarketingEligibilityConfig(remarketEligibility?.status)?.text : ''
      }
    >
      {messages.submissionWorkspace.marketRequestsWorkspace.addProducts}
    </Button>
  );
}
